import { SEND_USER_PASSWORD } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SEND_USER_PASSWORD.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEND_USER_PASSWORD.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SEND_USER_PASSWORD.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
